var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrap-container',[_c('modal-component',{attrs:{"show":_vm.show,"label":_vm.titleModal,"button-label":"Cerrar"},on:{"close":_vm.onClose,"aceptar":_vm.onClose}},[_c('div',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.textModal),expression:"textModal"}],staticClass:"text"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }